import { Pipe, PipeTransform } from "@angular/core";

/** Replaces negative time values with 0.00. */
@Pipe({
  name: "hssDuration",
  standalone: true,
})
export class HssDurationPipe implements PipeTransform {
  transform(value: string): string {
    if (value.includes("-")) {
      return "0.00";
    }
    return value;
  }
}
